import React from 'react';
import {Col, Row} from "react-bootstrap";
import style from './OurServices.module.scss';
import supportImage from '../../../../asset/images/icon/poshtibani.svg';
import searchImage from '../../../../asset/images/icon/asan-search.svg';
import advisorImage from '../../../../asset/images/icon/moshavere.svg';

class OurServices extends React.Component{
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div>
        <Row className={'justify-content-center'}>
          <Col xs={12} md={4} className={'text-right'}>
            <div className={`${style.box} d-flex align-items-center `}>
              <div className={'d-flex flex-column align-items-center align-items-lg-end'}>
                <span className={`${style.title}`}>
                  پشتیبانی حرفه ای
                </span>
                <span className={`${style.description}`}>
                  برای تجربه یک معامله سودمند قطعا به راهنمایی افراد خبره در این حوزه نیاز خواهید داشت
                </span>
              </div>
              <div className={`${style.logo} ${style.support} d-flex align-items-center justify-content-center`}>
                <img src={supportImage} alt="Advisor"/>
              </div>
            </div>
          </Col>
          <Col xs={12} md={4} className={'text-right'}>
            <div className={`${style.box} d-flex align-items-center `}>
              <div className={'d-flex flex-column align-items-center align-items-lg-end'}>
                <span className={`${style.title}`}>
                  جستجوی آسان ملک
                </span>
                <span className={`${style.description}`}>
                  هوم پلاک تجربه شیرین معامله مسکن در دنیای مدرن است
                </span>
              </div>
              <div className={`${style.logo} ${style.search} d-flex align-items-center justify-content-center`}>
                <img src={searchImage} alt="Advisor"/>
              </div>
            </div>
          </Col>
          <Col xs={12} md={4} className={'text-right'}>
            <div className={`${style.box} d-flex align-items-center `}>
              <div className={'d-flex flex-column align-items-center align-items-lg-end'}>
                <span className={`${style.title}`}>
                  مشاوره رایگان
                </span>
                <span className={`${style.description}`}>
                مشاوران ما در هیچ یک از مراحل شما را تنها نمی گذارند و با کمال احترام رفتار می کنند
                </span>
              </div>
              <div className={`${style.logo} ${style.advisor} d-flex align-items-center justify-content-center`}>
                <img src={advisorImage} alt="Advisor"/>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}

export default OurServices;
